import SoDRepository, {
  SoDPrecheckResult,
} from "@/core/administration/repositories/SoDRepository";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { Permission } from "@/core/administration/entities/Rule";
import { RepositoryResult } from "@/core/shared/types/RepositoryResult";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import { getSodPrecheckUrl } from "../../api/rbacBackendEndpoints/rbacBackendEndpoints";

export default class SoDRepositoryBackend implements SoDRepository {
  constructor(private readonly httpClient: HttpClient) {}

  precheck(
    permissions: Permission[],
  ): Promise<RepositoryResult<SoDPrecheckResult>> {
    const permissionsPayload = permissions.map((p) => ({
      name: p.label,
      domaine: p.domain,
      action: p.action,
      ressource: p.resource,
    }));

    return executeRequest(
      () =>
        this.httpClient.post<ApiResponse<SoDPrecheckResult>>({
          url: getSodPrecheckUrl(),
          withAuth: true,
          body: permissionsPayload,
        }),
      (d) => d,
    );
  }
}
